import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { useAuth } from './AuthProvider';
import api from '../utils/api';

const Ctx = createContext({ count: 0, refresh: () => {} });

// eslint-disable-next-line react-refresh/only-export-components
export const useReviewQueue = () => useContext(Ctx);

export default function ReviewQueueProvider({ children }) {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) return;
    try {
      const items = await api.toReview();
      setCount(items.length);
    } catch {
      setCount(0);
    }
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return <Ctx.Provider value={{ count, refresh }}>{children}</Ctx.Provider>;
}
